import { render, staticRenderFns } from "./ProductCategoriesAccordion.vue?vue&type=template&id=2f34d058&"
import script from "./ProductCategoriesAccordion.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoriesAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCategoriesAccordion.vue?vue&type=style&index=0&id=2f34d058&prod&lang=scss&scopen=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports